import { runWithAdal } from "react-adal";
import { authContext } from "@src/api/config";
import { ConfigProvider } from "antd";
import "react-app-polyfill/stable";
import "antd-mobile/dist/antd-mobile.css";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store, persistor } from "@src/redux/store";
import * as serviceWorker from "./serviceWorker";
import { MsalProvider } from "@azure/msal-react";
import { getMsalInstance } from "./api/config";
import AppRoutes from "./AppRoutes";
// Lang
import jaJP from "antd/lib/locale/ja_JP";
import moment from "moment";
import "moment/locale/ja";
import { PersistGate } from "redux-persist/integration/react";
moment.locale("ja_JP");

jaJP.Empty.description = "データがありません。";
const msalInstance = getMsalInstance();
const DO_NOT_LOGIN = false;
// Ensure redirect is fully handled before rendering
msalInstance
  .handleRedirectPromise()
  .then((response) => {
    ReactDOM.render(
      <MsalProvider instance={msalInstance}>
        <ConfigProvider locale={jaJP}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <BrowserRouter>
                <AppRoutes />
              </BrowserRouter>
            </PersistGate>
          </Provider>
        </ConfigProvider>
      </MsalProvider>,
      document.getElementById("root")
    );
  })
  .catch((error) => {
    console.error("MSAL redirect error:", error);
  });

serviceWorker.register();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
